import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'complete-tab',
    templateUrl: './complete-tab.component.html',
    styleUrls: ['./complete-tab.component.scss'],
    standalone: false
})
export class CompleteTabComponent implements OnChanges  {
  @Input() authorizationNumber = '';
  @Input() isExternal: boolean;
  @Input() showPendingAnalyticsMessage?: boolean;
  @Input() isPASCompleteFlow: boolean;
  @Input() isAutoApproved: boolean;

  @Output() navigateToHome = new EventEmitter<void>();
  @Output() navigateToAuthorization = new EventEmitter<void>();
  @Output() navigateToMember = new EventEmitter<void>();
  @Output() navigateToOriginLoPACAuth = new EventEmitter<void>();

  showRedirectToAuthPage = false;
  analyticsMessage = '';

  ngOnChanges(changes: SimpleChanges): void {
    const { authorizationNumber } = changes;

    this.showRedirectToAuthPage = authorizationNumber?.currentValue && !authorizationNumber?.currentValue.includes('*');
    this.analyticsMessage = this.isExternal ? 'You will receive an email notification with any next steps once the request has been reviewed.' : 'Your request will be reviewed.';
  }
}
